import React from 'react'
import { useGenericRequestHandler } from '../../handlers/useGenericRequestHandler'

const PRODUCT_UNLIMITED_VOLUME = 'unlimited_volume'
const PRODUCT_ESSENTIAL_VOLUME = 'essential_volume'

function decorateWithCurrencySymbols(products) {
  const symbolMap = {}

  for (const row of products.currencies) {
    symbolMap[row.currencyCode] = row.symbol
  }

  products.currencySymbols = symbolMap

  return products
}

function schoolProductsAreValid(schoolProducts) {
  if ('products' in schoolProducts) {
    const { products } = schoolProducts
    if (
      PRODUCT_ESSENTIAL_VOLUME in products &&
      PRODUCT_UNLIMITED_VOLUME in products
    ) {
      return true
    }
  }
  return false
}

export const useProductsQuery = (
  params = {
    queryParams: { provider: 'chargebee' },
    forSchools: false,
    enabled: true
  }
) => {
  const { queryParams, forSchools, enabled } = params
  const { data, error, loading, ...rest } = useGenericRequestHandler({
    route: `c/products?${new URLSearchParams(queryParams).toString()}`,
    method: 'GET',
    enabled
  })
  const [newData, setNewData] = React.useState(null)

  React.useEffect(() => {
    if (!enabled || loading || error || newData || !data) return

    const products = decorateWithCurrencySymbols(data)

    if (forSchools) {
      if (!schoolProductsAreValid(data)) {
        throw new Error('Invalid school products')
      }
    }

    setNewData(products)
  }, [loading, error, data, newData])

  return { data: newData, loading, error, ...rest }
}
